<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Bookings & Actuals</span><br/>
      <span style="font-style: italic; font-size: 18px">view bookings by date range, click + for details, click Download for a CSV with these results</span>
    </div>

    <div v-if="!this.$route.query.booking_id" style="font-size: 18px; font-weight: bold; position: relative; margin: 20px 0px 20px 0px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 18px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 18px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;<b-form-select v-model="actuals_filter" :options="actuals_filter_options" style="font-size: 18px; font-weight: bold; width:190px"/>
      <span v-if="company_options">
        &nbsp;&nbsp;|&nbsp;&nbsp;<b-form-select v-model="selected_company" :options="company_options" style="font-size: 18px; font-weight: bold; width:180px"/>
      </span>
      <span v-if="type_options">
      &nbsp;&nbsp;|&nbsp;&nbsp;<b-form-select v-model="selected_type" :options="type_options" style="font-size: 18px; font-weight: bold; width:150px"/>
      </span>
      &nbsp;&nbsp;<b-button v-on:click.prevent="search_by_date_range()">Search</b-button>
      &nbsp;&nbsp;<b-form-input style="width: 165px" v-model="booking_search" placeholder="search by charterID"/>
      &nbsp;&nbsp;<b-button v-on:click.prevent="search_by_id()">Search</b-button>
      &nbsp;&nbsp;Filter&nbsp;<b-form-input style="width: 150px" v-model="booking_filter" placeholder="filter"/>
      <span v-if="base_options && base_options.length > 2">
        &nbsp;&nbsp;|&nbsp;&nbsp;<b-form-select v-model="selected_base" :options="base_options" style="font-size: 18px; font-weight: bold; width:150px"/>
      </span>
<!--      &nbsp;|&nbsp;&nbsp;<b-button variant="success" size="md" @click="download">Download</b-button>-->
    </div>

    <div v-if="!this.$route.query.booking_id && !loading" style="margin: 20px;">
      <div class="row" style="margin: 10px; font-weight: bold; font-size: 24px;">
        <div @click="filter_by_status(null)" class="col" style="border: 1px solid grey;">{{ items.length }} of {{items_full.length}}</div>
<!--        <div @click="filter_by_status('success')" class="col success" style="border: 1px solid grey;">Succeeded: {{success_cnt}}</div>-->
<!--        <div @click="filter_by_status('error')" class="col error" style="border: 1px solid grey;">Errored: {{error_cnt}}</div>-->
<!--        <div @click="filter_by_status('cancelled')" class="col cancelled" style="border: 1px solid grey;">Cancelled: {{cancelled_cnt}}</div>-->
<!--        <div @click="filter_by_status('unprocessed')" class="col unprocessed" style="border: 1px solid grey;">Unprocessed: {{unprocessed_cnt}}</div>-->
<!--        <div style="border: 1px solid white;"><b-button v-on:click.prevent="reprocess_actuals()">Reprocess Actuals</b-button></div>-->
      </div>
    </div>

    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage" :tbody-tr-class="get_row_color"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
        
        <template slot="status_msg" slot-scope="row">
          <div style="text-align: left" v-for="msg in row.item.status_msg.split(',')">
            <span v-html="msg"/>
          </div>
        </template>

        <template slot="notes" slot-scope="row">
          <b-form-input style="width:250px" v-model="row.item.notes" v-on:blur="save_notes(row.item)" @keydown.enter.native="save_notes(row.item)"/>
        </template>

        <template slot="reprocess" slot-scope="row">
          <span v-if="enable_reprocess" size="sm" @click="reprocess_alert(row.item)"><span style="font-size: 35px;">&#8635;</span></span>
        </template>

        <template slot="scheduled_departure_time" slot-scope="row">
          {{row.item.scheduled_departure_time | formatDateTimeSmall}}
        </template>

        <template slot="scheduled_pickup_time" slot-scope="row">
          {{row.item.scheduled_pickup_time | formatDateTimeSmall}}
        </template>

        <template slot="scheduled_end_time" slot-scope="row">
          {{row.item.scheduled_end_time | formatDateTimeSmall}}
        </template>

        <template slot="modified_time" slot-scope="row">
          {{row.item.modified_time | formatDateTime}}
        </template>

        <template slot="details" slot-scope="row">
          <div style="align-content: center">
            <b-button size="sm" @click="row.toggleDetails">
              {{ row.detailsShowing ? '-' : '+' }}
            </b-button>&nbsp;
          </div>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-card style="text-align: left; border: 1px solid grey">
            <table width="100%">
              <tr>
                <th>Event</th>
                <th>Planned Time</th>
                <th>HOS Time</th>
                <th>HOS Delta</th>
                <th>Vehicle Actual Time</th>
                <th>Vehicle Delta</th>
                <th>Planned Location</th>
              </tr>
              <tr>
                <td>Pickup Time</td>
                <td>{{row.item.actual.movement.PickupDateTime | formatDateTimeTZ}}</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>{{row.item.actual.actualPickupDateTime | formatDateTimeTZ}}</td>
                <td>{{get_time_diff(row.item.actual.plannedPickupDateTime,row.item.actual.actualPickupDateTime)}}</td>
                <td><span v-html="row.item.actual.pickupMapLink"/></td>
              </tr>
              <tr>
                <td>Dropoff Time</td>
                <td>{{row.item.actual.movement.FinishDateTime | formatDateTimeTZ}}</td>
                <td>{{row.item.actual.nearestLogoutFinishDateTime | formatDateTimeTZ}}</td>
                <td>{{get_time_diff(row.item.actual.plannedFinishDateTime,row.item.actual.nearestLogoutFinishDateTime)}}</td>
                <td>{{row.item.actual.nearestLocationFinishDateTime | formatDateTimeTZ}}</td>
                <td>{{get_time_diff(row.item.actual.plannedFinishDateTime,row.item.actual.nearestLocationFinishDateTime)}}</td>
                <td><span v-html="row.item.actual.finishMapLink"/></td>
              </tr>
            </table>
            <br/>
            <div v-html="row.item.actual.samsara_links"/>
            <span>
              <b>Map Links: </b>
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/vehicle-track/' + user.tenant + '/' + row.item.vehicle }">Track Vehicle</router-link>
              &nbsp;|&nbsp;
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/fleet-track/' + user.tenant + '/bookingType/' + row.item.bookingType }">Track '{{row.item.bookingType}}' Vehicles</router-link>
              &nbsp;|&nbsp;
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/fleet-track/' + user.tenant + '/clientID/' + row.item.clientID }">Track '{{row.item.clientID}}' Vehicles</router-link>
              &nbsp;|&nbsp;
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/fleet-track/' + user.tenant + '/booking/' + row.item.charterID }">Track Booking '{{row.item.charterID}}' Vehicles</router-link>
              &nbsp;|&nbsp;
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/fleet-track/' + user.tenant + '/movement/' + row.item.bookingID }">Track Movement '{{row.item.movementID}}' Vehicles</router-link>
              &nbsp;|&nbsp;
              <router-link style="font-weight: bold;" :to="{ path: '/vehicle_trip_history?vehicleId=' + row.item.vehicle }">Trip History</router-link>
            </span>

            <div class="row" style="margin: 10px 0px 0px 10px">
              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.source_actualStartDateTime">
                <div><b>Calc Event Source:</b></div>
                <div>Start Time: {{row.item.actual.source_actualStartDateTime | nearest }}</div>
                <div>Finish Time: {{row.item.actual.source_actualFinishDateTime | nearest }}</div>
              </span>

              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.nearestLoginStartDateTime || row.item.actual.nearestEngineOnStartDateTime || row.item.actual.nearestLocationStartDateTime">
                <b>Start Event Times:</b><br/>
                HOS On Duty: {{row.item.actual.nearestLoginStartDateTime | formatDateTime}}<br/>
                DVIR Pre Trip Time: {{row.item.actual.nearestPreTripDVIRDateTime | formatDateTime}}<br/>
                Vehicle Key On: {{row.item.actual.nearestEngineOnStartDateTime | formatDateTime}}<br/>
                Vehicle Start Leave: {{row.item.actual.nearestLocationStartDateTime | formatDateTime}}
              </span>
              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.nearestLogoutFinishDateTime || row.item.actual.nearestEngineOffFinishDateTime || row.item.actual.nearestLocationFinishDateTime">
                <b>Finish Event Times:</b><br/>
                HOS Off Duty: {{row.item.actual.nearestLogoutFinishDateTime | formatDateTime}}<br/>
                DVIR Post Trip Time: {{row.item.actual.nearestPostTripDVIRDateTime | formatDateTime}}<br/>
                Vehicle Key Off: {{row.item.actual.nearestEngineOffFinishDateTime | formatDateTime}}<br/>
                Vehicle Finish Arrival: {{row.item.actual.nearestLocationFinishDateTime | formatDateTime}}
              </span>
            </div>
            <div class="row" style="margin: 10px 0px 0px 10px">
              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.actualTotalDistance">
                <b>Distances (miles)</b><br/>
                Planned Total: {{row.item.plannedDistance}}<br/>
                Trip Total: {{row.item.actual.actualTotalDistance}}<br/>
                Start Odometer: {{row.item.actual.actualStartOdometer}}<br/>
                End Odometer: {{row.item.actual.actualEndOdometer}}<br/>
                Odometer Total: {{row.item.actual.actualEndOdometer - row.item.actual.actualStartOdometer}}
              </span>
              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.jurisdictionDistances">
                <b>State Distances (miles)</b><br/>
                <div v-for="dist in row.item.actual.jurisdictionDistances">
                  {{dist.jurisdiction}} : {{dist.distance}}m
                </div>
              </span>
              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.actualLiveDistance">
                <b>Live & Dead Mileage (miles):</b><br/>
                Live Mileage: {{row.item.actual.actualLiveDistance}}<br/>
                Dead Mileage: {{row.item.actual.actualEmptyDistance}}{{row.item.actual.actualDeadDistance}}<br/>
              </span>
              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.actualHOSOnDuration">
                <b>Driver HOS Activity (minutes):</b><br/>
                Total On Duty: {{row.item.actual.actualHOSOnDuration}}<br/>
                Total Off Duty: {{row.item.actual.actualHOSOffDuration}}<br/>
                Total Driving : {{row.item.actual.actualHOSDrivingDuration}}<br/>
              </span>
            </div>
          </b-card>
        </template>
      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

    import {api_url, get_fasttrak_actuals } from '../networking/apis'
    import {mapState} from "vuex";
    import moment from 'moment'
    import {justDate} from "@/helpers/dates";
    import axios from 'axios';

    export default {
      name: 'actuals_fasttrak',
      components: {
      },

      data() {
        return {
          msg: 'actuals',
          items: [],
          items_full: [],
          selected_status: null,
          summary: [],
          loading: true,
          company_options: null,
          type_options: null,
          base_options: [],
          selected_company: '',
          selected_base: '',
          selected_type: '',
          details_fromDate: justDate(moment()),
          details_toDate: justDate(moment()),
          totalRows: 1,
          currentPage: 1,
          perPage: 100,
          pages: [],
          actuals_filter: 'finish',
          booking_filter: '',
          booking_search: '',
          actuals_filter_options: [
            { value: 'finish', text: 'By Finish Date' },
            { value: 'start', text: 'By Start Date' },
            { value: 'overlap', text: 'Overlaps Range' },
          ],
          fields: [
            // { key: 'details', label: '', sortable: false},
            { key: 'reservation_id', sortable: true},
            { key: 'reservation_status', label: 'Status', sortable: true},
            { key: 'modified_time', label: 'Last Updated', sortable: true},
            { key: 'vehicle_name', label:'Vehicle', sortable: true},
            { key: 'driver_name', label: 'Driver', sortable: true},
            { key: 'trip_type', label: 'Type', sortable: true},
            { key: 'scheduled_departure_time', label:'Departure Time', sortable: true},
            { key: 'scheduled_pickup_time', label:'Pickup Time', sortable: true},
            { key: 'from_location', label: 'Pickup', sortable: true},
            { key: 'scheduled_end_time', label: 'Dropoff', sortable: true},
            { key: 'to_location', label: 'Dropoff Time', sortable: true},
          ],
          enable_reprocess: false
          ,
          options: {
            format: 'MM-DD-YYYY',
            useCurrent: true,
            minDate: moment().subtract(360, 'days'),
            maxDate: moment().add(180, 'days'),
            keepOpen: false,
            showClear: true,
            showClose: true,
            toolbarPlacement: 'top',
          },

        }
      },

      async created() {
        this.fields_all = this.fields
        this.check_features()
      },
      methods: {
        async check_features() {
          this.check_cols()
          this.load_data()
        },
        async check_cols() {
          this.delete_enabled = this.user.role == 'admin' || this.user.role == 'customer-admin'
          this.fields = this.fields_all
          if (!this.delete_enabled)
            this.fields = this.fields.filter(item => item.key != 'delete')
          if (this.user.role != 'admin')
            this.fields = this.fields.filter(item => item.key != 'bookingID' && item.key != 'last_updated')
          if (!this.user.features[this.user.tenant].booking_notes_enabled)
            this.fields = this.fields.filter(item => item.key != 'notes')
        },
        async search_by_date_range() {
          this.booking_search = ''
          this.load_data()
        },
        async search_by_id() {
          this.booking_filter = ''
          this.load_data()
        },
        async load_data() {
          this.loading = true
          try {
            if (this.$route.query.booking_id)
              this.booking_search = this.$route.query.booking_id

            try {
              const {value: {data = []}} = await get_fasttrak_actuals(this.user.tenant, this.actuals_filter, this.booking_search, this.selected_company, this.selected_type, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
              this.summary = data.summary
              moment.tz.setDefault(this.summary.timezone)
              this.items = data.results
              this.items_full = data.results

              if (data.summary.companies && data.summary.companies.length > 2)
                this.company_options = data.summary.companies

              this.type_options = data.summary.types
              this.base_options = data.summary.bases
              this.filter_results()

              if (this.summary.total_cnt != this.items_full.length) {
                this.$emit('showAlert', 'too many results to process for ' + this.booking_search + ', showing partial results', 'warning', 10000)
              }

              if (this.user.tenant.includes('aaahi')) {
                this.enable_reprocess = true
              } else {
                this.enable_reprocess = false
              }
            } catch(e){
              this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
            }
          } catch(e){
            this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
          }
          this.loading = false
        },
        async download(){
          this.$emit('showAlert', 'processing download request', 'info', 10000)
          axios.defaults.headers.common.Accept = {}
          axios.post(
              `${api_url}bookings/actuals/download`,
              {
                tenant: this.user.tenant,
                filter: this.actuals_filter,
                company: this.selected_company,
                type: this.selected_type,
                status: this.selected_status,
                fromDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
                toDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
              }, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                  Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                responseType: 'blob'
              }
          ).then((response) => {
            axios.defaults.headers.common.Accept = 'application/json'
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'download',
                `actuals-${this.user.tenant}-${this.details_fromDate}-${this.details_toDate}.csv`
            )
            document.body.appendChild(link)
            link.click()
            this.$emit('showAlert', 'download complete', 'success', 5000)
          }).catch(e => {
            axios.defaults.headers.common.Accept = 'application/json'
            this.$emit('showAlert', 'actuals data could not be downloaded.', 'danger')
          })
        },
        async shift_detail_graph_date(shift) {
          this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
          this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
          this.booking_id_filter = ''
        },
        get_time_diff(time1, time2) {
          if (time1 != null && time2 != null)
            return Math.round((new Date(time2) - new Date(time1)) / (1000 * 60)) + 'm';
          return ''
        },
        toggle_div(item,field) {
          item[field] = !item[field];
          this.$forceUpdate();
        },
        get_row_color(item, type) {
            if (!item || type !== 'row') return
            return item.status
        },
        filter_by_status(status) {
          if (status == null || this.selected_status == status) {
            this.selected_status = null
          } else {
            this.selected_status = status
          }
          this.filter_results()
        },
        filter_results() {
          this.items = this.items_full
          if (this.booking_filter) {
            const val = this.booking_filter

            this.items = this.items.filter(item => (this.contains(item.bookingID, val) ||
                this.contains(item.driver_name, val) ||
                this.contains(item.vehicle_name, val) ||
                this.contains(item.to_lcoation, val) ||
                this.contains(item.from_location, val) ||
                this.contains(item.trip_type, val) ||
                this.contains(item.passenger_name, val) ||
                this.contains(item.reservation_id, val) ||
                this.contains(item.reservation_status, val)))
          }

          if (this.selected_status) {
            this.items = this.items.filter(item => item.status == this.selected_status)
          }
          if (this.selected_company) {
            this.items = this.items.filter(item => this.contains(item.companyID,this.selected_company))
          }
          if (this.selected_base) {
            this.items = this.items.filter(item => this.contains(item.bookingBase,this.selected_base) || this.contains(item.startBase,this.selected_base) || this.contains(item.finishBase,this.selected_base))
          }
        },
        contains(val1, val2) {
          if (val1 != null) {
            return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
          }
          return false;
        }
      },
      computed:{
        ...mapState({
          user: state => state.profile.user
        }),
        success_cnt() {
          return this.items_full.filter(item => item.status == 'success').length
        },
        error_cnt() {
          return this.items_full.filter(item => item.status == 'error').length
        },
        cancelled_cnt() {
          return this.items_full.filter(item => item.status == 'cancelled').length
        },
        unprocessed_cnt() {
          return this.items_full.filter(item => item.status == 'unprocessed').length
        },
      },
      watch: {
        user: {
          deep: true,
          handler() {
            this.load_data()
          }
        },
        booking_filter() {
          this.filter_results()
        },
        selected_base() {
          this.filter_results()
        },
      }
    }
</script>

<style>

.error { background-color: rgba(255,0,0,0.25)}
.success { background-color: hsla(120,100%,75%,0.3)}
.unprocessed { background-color: hsla(200,40%,80%,0.3) }
.cancelled { background-color: hsla(290,60%,70%,0.3) }

.error td { background-color: rgba(255,0,0,0.25)}
.success td {background-color: hsla(120,100%,75%,0.3)}
.unprocessed td { background-color: hsla(200,40%,80%,0.3) }
.cancelled td { background-color: hsla(290,60%,70%,0.3) }


div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

</style>

